import React from 'react';
import styled from 'styled-components';
import { AiOutlineCopyright } from 'react-icons/ai';
import theme from '@styles/theme';

const Footer = () => {
	const year = new Date().getFullYear();

	return (
		<Wrapper>
			<Inner>
				<Copyright>
					{year}
					<AiOutlineCopyright />
					<Company>rocknrun company</Company>
				</Copyright>
				<Status>Maintenance</Status>
			</Inner>
		</Wrapper>
	);
};

export default Footer;

const Wrapper = styled.footer`
	width: 100%;
	margin-top: 120px;
	height: 180px;
`;
const Inner = styled.div`
	width: 1280px;
	margin: 0 auto;
	padding: 10px 0;
	/* background-color: green; */
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const Copyright = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	font-size: 13px;
	color: ${theme.colors.lightGrayFontColor};
`;
const Company = styled.span`
	margin-left: 4px;
	font-family: PretendardMedium, sans-serif;
	color: ${theme.colors.blackColor};
`;
const Status = styled.span`
	font-size: 13px;
	color: ${theme.colors.lightGrayFontColor};
`;
